/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import { useI18n } from "hooks/i18n/i18n";
import { Link } from "react-router-dom";
import { changeStyleWithHosting } from "utility/hosting";

import type { FC } from "react";

type Props =
  | {
      isPhoneNumberVerified: true;
      phoneNumber: string;
    }
  | {
      isPhoneNumberVerified: false;
    };

export const ResaleApplicationPhoneVerification: FC<Props> = (props) => {
  const { t } = useI18n();
  const classes = styles();

  if (props.isPhoneNumberVerified) {
    return (
      <p css={classes.verified}>
        <CheckCircleIcon css={classes.verifiedIcon} aria-hidden="true" />
        <span>
          {t("event.resale.entry.verifiedPhoneNumber", {
            phoneNumber: props.phoneNumber,
          })}
        </span>
      </p>
    );
  }

  return (
    <section css={classes.unverified}>
      <h2 css={classes.unverifiedTitle}>
        <ErrorIcon css={classes.unverifiedIcon} aria-hidden="true" />
        <span>{t("event.resale.entry.phoneNumberVerificationRequired")}</span>
      </h2>
      <p css={classes.unverifiedDescription}>
        {t("event.resale.entry.phoneNumberVerificationDescription")}
      </p>
      <Link
        to="/account/edit"
        target="_blank"
        rel="noopener noreferrer"
        css={classes.verifyLink}
      >
        {t("event.resale.entry.verifyPhoneNumber")}
      </Link>
    </section>
  );
};

const styles = () => {
  const { accentColor } = changeStyleWithHosting().baseStyles;

  return {
    unverified: css`
      padding: 12px;
      background-color: #fff;
      border: 2px solid #f00;
    `,
    unverifiedDescription: css`
      margin: 8px 0 0;
      color: #777;
      font-size: 12px;
      line-height: 1.7;
    `,
    unverifiedIcon: css`
      flex: none;
      color: #f00;
      font-size: 18px;
    `,
    unverifiedTitle: css`
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.5;
    `,
    verified: css`
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 12px;
      color: #222;
      font-size: 12px;
      font-weight: bold;
      line-height: 1.5;
      background-color: #f5f5f5;
    `,
    verifiedIcon: css`
      flex: none;
      color: ${accentColor};
      font-size: 18px;
    `,
    verifyLink: css`
      display: block;
      box-sizing: border-box;
      width: 100%;
      min-height: 40px;
      padding: 8px 16px;
      margin-top: 12px;
      color: ${accentColor};
      font-family: inherit;
      font-size: 12px;
      font-weight: bold;
      line-height: 1.5;
      text-align: center;
      text-decoration: none;
      background-color: #fff;
      border: 2px solid ${accentColor};
      cursor: pointer;
    `,
  };
};
